<template>
  <div id="batch-list">
    <div class="page-toolbar bg-white shadow-sm p-3 justify-content-between align-items-center">
      <div class="d-flex justify-content-between ">
        <h4 class="m-0 ">
          Batch File
        </h4>
        <b-button
          size="sm"
          class="ml-1 mr-3"
          @click="onAddNewBatchClick"
        >
          <font-awesome-icon :icon="['fas', 'plus']" />
          Create new batch
        </b-button>
      </div>
    </div>

    <content-spinner :show="loading" />

    <div
      v-if="!loading"
      class="inner-content p-3"
    >
      <complex-table-view
        :is-file-manipulation-controller="true"
        :small="true"
        :fields="fields"
        :items="items"
        :total-rows="items.length"
        :modal-name="`batch-list-view`"
        :action-buttons="actionButtons"
        @on-edit="onEditClick"
        @on-delete="onDeleteClick"
        @file-list-click="onBatchFileListClick"
        @filter="onFilter"
      />
    </div>

    <add-edit-batch-modal v-if="isAddEditBatchModalOpen" />
    <batch-file-list-view-modal @on-update="getData" />
  </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';
import ComplexTableView from '../../../core/components/complex-table/components/ComplexTableView';
import ContentSpinner from '../../../core/components/ContentSpinner';
import AddEditBatchModal from './components/AddEditBatchModal';
import BatchFileListViewModal from './components/BatchFileListViewModal';
import filterMixin from '../../../core/mixins/filter.mixin';

const {mapActions, mapState} = createNamespacedHelpers('fileManipulationController');

export default {
  name: 'BatchListView',
  components: {
    BatchFileListViewModal,
    AddEditBatchModal,
    ContentSpinner,
    ComplexTableView,
  },
  mixins: [filterMixin],
  data() {
    return {
      loading: false,
      fields: [
        {
          key: 'batchName',
          name: 'batchName',
          dataTypeName: 'text',
          label: 'Name',
        },
      ],
      items: [],
      actionButtons: {
        delete: true,
        fileList: true,
      },
    };
  },
  watch: {
    ['batchList']() {
      this.items = [...this.batchList];
    },
  },
  computed: {
    ...mapState({
      batchList: state => state.batchList,
      isAddEditBatchModalOpen: state => state.addEditModal.show,
    }),
  },
  methods: {
    ...mapActions([
      'getBatchList',
      'deleteBatch',
      'showBatchFileListModal',
      'showAddEditModal',
    ]),
    onAddNewBatchClick() {
      this.showAddEditModal();
    },
    onEditClick(item) {
      this.showAddEditModal(item);
    },
    onBatchFileListClick(batch) {
      this.showBatchFileListModal(batch);
    },
    onFilter(filters) {
      const filter = filters.filter || filters;
      this.items = this.batchList.filter(item => {
        for (const filterFieldName in filter) {
          if (!filter.hasOwnProperty(filterFieldName)) {
            continue;
          }
          const field = this.fields.find((f) => f.name === filterFieldName);
          if (field.dataTypeName === this.fieldValues.text && !this.textFilter(filter[filterFieldName], item[filterFieldName])) {
            return false;
          }
        }
        return true;
      });
    },
    async onDeleteClick(index) {

      const confirmed = await this.$confirm('Deleting Record...', 'You are deleting record. Are you sure you want to continue?');

      if (confirmed) {
        const batch = this.batchList.find((b, idx) => idx === index);

        const {success, body} = await this.deleteBatch(batch);
        if (success) {
          this.$toasted.success('Deleted successfully', {
            duration: TOASTER_DURATION,
          });
        } else {
          this.$toasted.error(body.ErrorMessage, {
            duration: TOASTER_DURATION,
          });
        }
      }
    },
    async getData() {
      await this.getBatchList();
    },
    prepareData() {
      this.items = [...this.batchList];
    },
  },
  async mounted() {
    this.loading = true;
    await this.getData();
    this.prepareData();
    this.loading = false;
  },
};
</script>

<style lang="scss">
#batch-list {

  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .action-th {
    width: 100px;
  }

  th.th-errors {
    min-width: 200px;
  }

  .inner-content {
    overflow: auto;
    flex: 1;
  }

  .card-body {
    padding: 0;
  }

  .table-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 24px;
    overflow: hidden;
    justify-content: flex-start;
  }

  tbody {
    tr:hover {
      cursor: pointer;
      background-color: #d0d0d0;
    }
  }

}
</style>